import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific file
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetFile = packet => {
  return {
    type: 'REQUEST_GET_FILE',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetFileSuccess = data => ({
  type: 'RECEIVE_GET_FILE_SUCCESS',
  data
})

export const receiveGetFileFail = data => ({
  type: 'RECEIVE_GET_FILE_FAIL',
  data
})

export const tryToGetFile = packet => (dispatch, getState) => {

  dispatch(requestGetFile(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/knowledge/' + packet.knowledge_id + '/files/' + packet.file_id, {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetFileSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetFileFail({errors:e, lastSubmit: packet}));
    })
}
